export default __webpack_public_path__ + "static/media/honey.2d94744f.png";